import { render, staticRenderFns } from "./OnBoardRequestForm.vue?vue&type=template&id=6dd8b92e&"
import script from "./OnBoardRequestForm.vue?vue&type=script&lang=js&"
export * from "./OnBoardRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports